import type { MailParticipant } from "./types";

export type ParticipantAction =
  | { kind: "popup"; open: () => void }
  | { kind: "link"; href: string };

/**
 * How a contact or company on a message can be opened. Legacy pages such as the customer
 * dashboard load the details popups from Vecta.js, which the Emails tab used before; React
 * pages don't, so they link to the record instead.
 */
export const getParticipantAction = (participant: MailParticipant): ParticipantAction | null => {
  if (!participant.canOpen) return null;

  if (participant.type === "contact" && window.showTaskContactDetails) {
    const open = window.showTaskContactDetails;
    return { kind: "popup", open: () => open(participant.id) };
  }

  if (participant.type === "company" && window.showTaskCompanyDetails) {
    const open = window.showTaskCompanyDetails;
    return { kind: "popup", open: () => open(participant.id) };
  }

  return participant.url ? { kind: "link", href: participant.url } : null;
};

/**
 * Adds the current page, with the selected email, as the place a legacy task page returns
 * to after saving. The task URLs from the server already carry a query string.
 */
export const withReturnLocation = (url: string): string =>
  `${url}&location=${encodeURIComponent(window.location.pathname + window.location.search)}`;

/** Opens a customer's Emails tab on a specific message. */
export const customerEmailsHref = (emailsUrl: string, mailId: string): string =>
  `${emailsUrl}?emailid=${encodeURIComponent(mailId)}`;
